module.exports = new __parcel__URL__("generic-no-results.fb302821.svg").toString();